import { Dispatch, SetStateAction, useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  deleteInterviewRoute,
  eventsInterviewKey,
  eventsKey,
} from '@features/events';
import axiosInstance from '@server/axiosInstance';
import { authContext } from '@staffedupusa/shared-components';
import { deleteEnterpriseInterviewRoute } from '@features/enterpriseEvents';

type UseDeleteInterviewProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  interviewStartTime: number;
};

export const useDeleteInterview = ({
  setErrorText = () => {},
  interviewStartTime,
}: UseDeleteInterviewProps) => {
  const client = useQueryClient();
  const { authData } = useContext(authContext);

  const { mutate: deleteInterview, isLoading: isDeletingInterview } =
    useMutation({
      mutationFn: (variables: { interview_id: number; body: string }) =>
        axiosInstance
          .post(
            authData?.user?.enterprise
              ? deleteEnterpriseInterviewRoute
              : deleteInterviewRoute,
            variables,
          )
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries(eventsKey);
          client.invalidateQueries(eventsInterviewKey);
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    deleteInterview,
    isDeletingInterview,
  };
};
